/** Bilder und Videos der Startseite (Texte kommen aus den Übersetzungen) */
export const HOME_KEY = 'page_home';

export const HOME_DEFAULTS = {
  hero_videos: [
    '/videos/5311257-hd_1920_1080_25fps.mp4',
    '/videos/7792304-hd_1920_1080_25fps.mp4',
    '/videos/7792297-hd_1920_1080_25fps.mp4',
  ],
  hero_poster: '/new_images/AdobeStock_968935396.webp',
  about_image: '/new_images/AdobeStock_277838747.webp',
  industry_images: [
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&q=80&auto=format&fit=crop',
    '/new_images/pexels-n-voitkevich-6214479.webp',
    '/new_images/AdobeStock_343004004.webp',
    '/new_images/pexels-clement-proust-363898785-31763537.webp',
    'https://images.unsplash.com/photo-1551076805-e1869033e561?w=1200&q=80&auto=format&fit=crop',
    '/new_images/pexels-photographwithart-16343598.webp',
    'https://images.unsplash.com/photo-1659989693434-727c2b1b8367?q=80&w=987&auto=format&fit=crop',
  ],
  benefit_images: [
    '/new_images/pexels-freestockpro-8670381.webp',
    '/new_images/AdobeStock_986081604.webp',
    '/new_images/flyd-mT7lXZPjk7U-unsplash.webp',
  ],
  step_images: [
    '/new_images/pexels-cottonbro-7439136.webp',
    '/new_images/pexels-yankrukov-7691694.webp',
    '/new_images/AdobeStock_334106203.webp',
    '/new_images/AdobeStock_267386573.webp',
  ],
  partner_logo: '/images/bbh_logo.png',
};
